import React from 'react';
interface IOSShadowProps {
  children: React.ReactNode;
  className?: string;
  intensity?: 'light' | 'medium' | 'strong';
  color?: string;
}
export function IOSShadow({
  children,
  className = '',
  intensity = 'medium',
  color = 'rgba(0,0,0,0.1)'
}: IOSShadowProps) {
  // iOS shadows are more subtle with layered effects
  const shadowStyles = {
    light: `shadow-[0_2px_4px_${color},0_0_1px_rgba(0,0,0,0.05)]`,
    medium: `shadow-[0_4px_10px_${color},0_0_1px_rgba(0,0,0,0.05)]`,
    strong: `shadow-[0_10px_15px_${color},0_0_1px_rgba(0,0,0,0.1)]`
  };
  return <div className={`${shadowStyles[intensity]} ${className}`} data-id="element-32">{children}</div>;
}